import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import MemberManagement from './components/MemberManagement';
import WeeklyAttendance from './components/WeeklyAttendance';
import AbsenceTracking from './components/AbsenceTracking';
import QRGenerator from './components/QRGenerator';
import QRCheckIn from './components/QRCheckIn';
import QuarterlyResults from './components/QuarterlyResults';
import MeetingHistoryManager from './components/MeetingHistoryManager';
import { AttendanceProvider } from './context/AttendanceContext';
import './App.css';

function App() {
  const [currentView, setCurrentView] = useState('dashboard');
  
  const handleNavigate = (view) => {
    setCurrentView(view);
  };

  return (
    <AttendanceProvider>
      <Router>
        <Routes>
          {/* Standalone Check-in Route */}
          <Route path="/checkin" element={<QRCheckIn />} />
          
          {/* Main Application with Header */}
          <Route path="/" element={
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
              <Header currentView={currentView} onNavigate={handleNavigate} />
              <main className="container mx-auto px-4 py-8">
                {currentView === 'dashboard' && <Dashboard onNavigate={handleNavigate} />}
                {currentView === 'members' && <MemberManagement onNavigate={handleNavigate} />}
                {currentView === 'attendance' && <WeeklyAttendance onNavigate={handleNavigate} />}
                {currentView === 'absences' && <AbsenceTracking onNavigate={handleNavigate} />}
                {currentView === 'qr-generator' && <QRGenerator onNavigate={handleNavigate} />}
                {currentView === 'results' && <QuarterlyResults onNavigate={handleNavigate} />}
                {currentView === 'history' && <MeetingHistoryManager onNavigate={handleNavigate} />}
                {currentView === 'check-in' && <QRCheckIn />}
              </main>
            </div>
          } />
          
          {/* Redirect any other routes to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AttendanceProvider>
  );
}

export default App;